import { useApiStore } from "@/stores/api/index.ts";
import useTwitter from "@/util/useTwitter.ts";

const { formatUsername } = useTwitter();

const fetchTweets = async (module, { username, buttonId, confirmed }) => {
  const api = useApiStore();
  const { getters, commit, state, rootState, dispatch } = module;
  const newTwitterFeed = {
    buttonId,
    tweets: [],
  };

  // disable fetching if DEV or TEST mode
  // comment out this block for testing
  if (!import.meta.env.PROD) {
    console.log("DEV mode: Fetching tweets disabled to save API calls.");
    return commit("storeTwitterFeed", newTwitterFeed);
  }

  if (!username) {
    // if no username, we don't want to fetch tweets
    commit("storeTwitterFeed", newTwitterFeed);
    return undefined;
  }
  if (!buttonId) {
    // if no buttonId, we don't want to fetch tweets
    return undefined;
  }
  if (!confirmed) {
    // if the username is not confirmed, we don't want to fetch tweets
    return undefined;
  }
  // Remove '@' symbol from username or extract username from URL
  const formattedUsername = formatUsername(username);
  const twitterFeed = state.twitterFeeds.find(
    (feed) => feed.buttonId === buttonId
  );
  const currentTweets = twitterFeed?.tweets || [];
  if (!currentTweets.length || rootState.showCMS) {
    try {
      const { data } = await dispatch("httpRequest", {
        func: api.fetchTweets(formattedUsername, buttonId),
        config: {
          isCms: false,
          isAuth: false,
        },
      });
      newTwitterFeed.tweets = data?.tweets || [];
      commit("storeTwitterFeed", newTwitterFeed);
    } catch (err) {
      console.error("Error fetching tweets", err);
    }
  }
  return getters.twitterFeed(buttonId);
};

export { fetchTweets };
